import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    dateFormatter,
    customFormatter,
    getFieldByPathFormatter,
    historyDataFormatter
} from 'util/Utils';

import HistoryDataModal   from 'shared/HistoryDataModal'
import {browserHistory, Link} from 'react-router';
import MDHistory from 'react-icons/lib/md/history';
import config from  '../../../config';
import {
    UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT, ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS
} from "actions/actionTypes";
import moment   from 'moment'
class AdminOrdersListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []
        if(!config.checkAccessRights.call(this,{ resources:['orders_edit']})){
            return null
        }
            menuItemsMap.push({onClick: 'editRecord', label: 'Edit'})
    //   //   menuItemsMap.push({onClick:  (row)=> {
    //     this.props.cancelRecord(row);
    // }, label: 'Cancel'})

        if (!row.Deleted) {
            menuItemsMap.push({onClick: 'showRemoveDialog', label: 'Delete'})
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    editRecord(row) {
        this.props.editRecord(row);
    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }




    hideHistoryDataModal() {
        this.setState({currentRecord: {}, historyDataModalVisible: false});
    }
    customLinkFormatter(cell, row) {
         if (_.get(row, 'CustomData.OrderID') || _.get(row, 'CustomData.OrderNumber')) {
            if (_.get(row, 'CustomData.OrderID') && _.get(row, 'CustomData.OrderNumber')) {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]",_.get(row, 'CustomData.OrderID') ) }>{_.get(row, 'CustomData.OrderNumber')}</a>
                );
            } else if (_.get(row, 'CustomData.OrderID')) {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", _.get(row, 'CustomData.OrderID')) }>Order
                        ID</a>
                );
            } else {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.shopUrl + '/admin/orders.json?name=%23' +  _.get(row, 'CustomData.OrderNumber')+ '&status=any'  }>#{ _.get(row, 'CustomData.OrderNumber')}</a>
                );
            }
        } else {
            return ''
        }

    }


    render() {
        //      console.log('state', this.state  );
        return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.adminOrders.data}   ref={(ref) => {
                    if (!this.tableRef && ref) {
                        this.tableRef = ref;

                    }
                }}
                                selectRow={{
                                    mode: 'checkbox',
                                    columnWidth: '29px',
                                    onSelect: this.props.onRowSelect,
                                    onSelectAll: this.props.onAllRowSelect,
                                    customComponent: this.props.customMultiSelect
                                }}
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >


                    <TableHeaderColumn width="40px" dataField="createdAt" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'name': 'createdAt', 'format': 'MM-DD YYYY'} }
                                       dataSort={true}>Create Date</TableHeaderColumn>

                    <TableHeaderColumn width="40px" dataField="createdAt" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'FulfilledAt.Date', 'format': 'MM-DD YYYY'} }
                                       dataSort={true}>Fulfilled At</TableHeaderColumn>
                    <TableHeaderColumn width="70px" formatExtraData={ {
                        path: ['UserID' ,'firstName'], path2: ['UserID' ,'lastName'], format: (value, arg2) => {
                             return value + ' ' + arg2
                        }
                    }}
                                       editable={ false } dataFormat={ customFormatter }
                                       dataField='UserID._id' dataAlign="center"
                                       dataSort={true}>Customer</TableHeaderColumn>
                    <TableHeaderColumn width="70px"dataFormat={ getFieldByPathFormatter }
                                       dataField='UserID.email'  formatExtraData={ {path: ['UserID', 'email']}}
                                       editable={ false }    dataAlign="center"
                                       dataSort={true}>Email</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataAlign="center" dataField='Status'  dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['Status'],
                                           format: (value) => {
                                               return _.startCase(value)
                                           }}}
                                        dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField="CustomData.OrderNumber"
                                       dataFormat={ this.customLinkFormatter }
                                       dataAlign="center" dataSort={true}>Order #</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center" dataField="ChangeLog"
                                       editable={ false } dataSort={true}
                                       dataFormat={ (cell, row)=> historyDataFormatter.call(this,row,{field:'Notifications'} )}>Messages</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center" dataField="WarehousePickupReminderSent"
                                       editable={ false } dataSort={true}
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['WarehousePickupReminderSent'],
                                           format: (value) => {
                                               if (_.size(value) >0) {
                                                    return moment(_.get(value, '0.createdAt')).format('MM-DD YYYY')
                                               } else {
                                                   return ''
                                               }
                                           }
                                       }}>4 Days Reminder</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center" dataField="WarehousePickupUserResponse"
                                       editable={ false } dataSort={true}
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['WarehousePickupUserResponse'],
                                           format: (value) => {
                                               if (_.size(value) >0) {
                                                    return <div>
                                                    <div className="purpleLighter">{ _.get(value, '0.CustomData.UserResponseMessage', '1')}</div>
                                                       <div>{moment(_.get(value, '0.createdAt')).format('MM-DD YYYY')}</div>
                                                   </div>
                                               } else {
                                                   return ''
                                               }
                                           }
                                       }}>User Response</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center" dataField="ChangeLog"
                                       editable={ false } dataSort={true}
                                       dataFormat={ (cell, row)=> historyDataFormatter.call(this,row,  {field:'ChangeLog'})}>Log</TableHeaderColumn>


                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="20px" dataAlign="center" columnClassName={'actions-column'}
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>
                <HistoryDataModal data={this.state.currentRecord} hideModal={this.hideHistoryDataModal.bind(this)}
                                show={this.state.historyDataModalVisible}></HistoryDataModal>
            </div>
        );
    }
}


export default AdminOrdersListTable;
